import { atom } from "recoil";

export const matomoInitAtom = atom<boolean>({
  key: "MatomoInitAtom",
  default: false,
});
